import { render, staticRenderFns } from "./Errordetail.vue?vue&type=template&id=5324922d"
import script from "./Errordetail.vue?vue&type=script&lang=js"
export * from "./Errordetail.vue?vue&type=script&lang=js"
import style0 from "./Errordetail.vue?vue&type=style&index=0&id=5324922d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports